module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/wine_6da1f1.jpg";